// extracted by mini-css-extract-plugin
export default {"code-box":"code-box__4PM+h","hint":"hint__DukVs","label":"label__AYnYn","actions":"actions__tzHCI","btn":"btn__5uv2F","dim":"dim__7-rzz"};